import { generateTheme } from '../helpers'
import colors from './colors'
import components from './components'
import typography from './typography'

const opencloudTheme = {
  theme: generateTheme({
    palette: {
      colors,
      primary: 'blue',
      secondary: 'red',
      type: 'light',
      themeKey: 'opencloud',
    },
    typography: {
      fontFamily: '"Fira Sans"',
      fontSize: 12,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      typography,
    },
  }),
  components,
}

export default opencloudTheme
